import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavbarToggler, Collapse, NavItem, NavLink, UncontrolledDropdown, DropdownItem, DropdownToggle, DropdownMenu } from "reactstrap";
import logo from '../../img/logo_text_black.png'
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";




function TopNavigation(props) {
  let navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);




  const toggle = () => setIsOpen(!isOpen);

  const handleBackToDiv = (name) => {
    document.getElementById(name).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  const handleSignIn = () => {
    props.history.push("/signup")
  }
  const handleGoExperience = () => {
    navigate('/experience')
  }
  const handleGoIntro = () => {
    navigate("/")
  }
  const handleGoPaper = () => {
    navigate('/archive')
  }
  const handleToggle = () => {
    setDropdownOpen(!dropdownOpen)
  }
  const handleGoProject = () => {
    navigate('/project')
  }
  const onMouseEnter = () => {
    setDropdownOpen(true)
  }

  const onMouseLeave = () => {
    setDropdownOpen(false)
  }

  return (
    <>
      <Navbar light expand="sm" color="faded" style={{
        zIndex: '200', position: 'sticky', top: 0, backgroundColor: 'white'
      }} >
        <div onClick={() => navigate('/')} >
          <img style={{ maxWidth: '100px', maxHeight: '90px' }}
            src={logo}
          />
        </div>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar >
          <Nav style={{ marginLeft: 'auto' }} navbar>
            <NavItem className='intro-top-navigate' onClick={handleGoIntro}>
              <NavLink  >Intro</NavLink>
            </NavItem>
            <NavItem className='intro-top-navigate' onClick={handleGoPaper}>
              <NavLink>Archive</NavLink>
            </NavItem>
            <NavItem className='intro-top-navigate' onClick={handleGoExperience}>
              <NavLink>Experience</NavLink>
            </NavItem>
            <NavItem className='intro-top-navigate' onClick={handleGoProject}>
              <NavLink>Project</NavLink>
            </NavItem>
            {/* <NavItem className='intro-top-navigate' onClick={handleBackToDiv.bind(this, 'intro-content-pricing')}>
              <NavLink  >Pricing</NavLink>
            </NavItem> */}
            {/* <NavItem className='intro-top-navigate' onClick={handleBackToDiv.bind(this, 'intro-footer')} >
              <NavLink  >About</NavLink>
            </NavItem> */}
          </Nav>



        </Collapse>
      </Navbar>


    </>
  )
}




export default TopNavigation